import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeStatusService } from '../employee-status/employee-status.service';
import { EmployeeStatusModel } from '../employee-status/model/employee-status.model';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-employee-status-edit',
  templateUrl: './employee-status-edit.component.html',
  styleUrls: ['./employee-status-edit.component.scss'],
  standalone: false
})
export class EmployeeStatusEditComponent implements OnInit, DirtyCheck {
  title: string = "New Employee Status";
  editForm: FormGroup;
  itemInfo: EmployeeStatusModel = { id: 0 };
  isFormDirty: boolean = false;
  permission: any;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private service: EmployeeStatusService,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService,
    public dialog: MatDialog) {

    let id = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: [null, [Validators.required, Validators.maxLength(50)]],
      name: [null, [Validators.required, Validators.maxLength(100)]],
      description: [null],
      is_active_status: [1],
      notice_period_1: [null],
      notice_period_2: [null],
      send_notification: [0],
      is_active: [1]
    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (id !== null && parseInt(id) !== 0) {
      this.loadItem(id);
    }

    this.permission = permissionService.getPagePermission("employee");
  }

  ngOnInit(): void {}

  isDirty(): boolean {
    return this.isFormDirty;
  }

  navBack(): void {
    this.router.navigate(['/employee/employee-status']);
  }

  loadItem(id: any): void {
    this.service.getById(id).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.itemInfo = response.data.status;
          if (this.itemInfo) {
            this.itemInfo.is_active_status = this.itemInfo.is_active_status ? Number(this.itemInfo.is_active_status) : 0;
            this.itemInfo.send_notification = this.itemInfo.send_notification ? Number(this.itemInfo.send_notification) : 0;
            this.itemInfo.is_active = this.itemInfo.is_active ? Number(this.itemInfo.is_active) : 0;
          }
          this.editForm.patchValue(this.itemInfo);
          this.title = "Editing: " + this.itemInfo.name;
          this.isFormDirty = false;
        } else {
          this.snackBarService.openSnackBar({ message: response.message, title: 'Failed!!!', type: 'error' });
        }
      },
      error: () => {
        this.snackBarService.openSnackBar({ message: 'Failed to get data from server.', title: 'Failed!!!', type: 'error' });
      }
    });
  }

  save(): void {
    if (this.editForm.valid) {
      Object.assign(this.itemInfo, this.editForm.value);
      this.service.update(this.itemInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            this.isFormDirty = false;
            this.snackBarService.openSnackBar({ type: 'success', title: 'Saved', message: 'Record updated successfully.' });
            this.navBack();
          } else {
            this.snackBarService.openSnackBar({ message: response.message, title: 'Failed!!!', type: 'error' });
          }
        },
        error: () => {
          this.snackBarService.openSnackBar({ message: 'Failed to update.', title: 'Failed!!!', type: 'error' });
        }
      });
    } else {
      this.editForm.markAllAsTouched();
    }
  }
}
